import React from "react";
import { Container, Row } from "react-bootstrap";

import iosButton from "assets/images/coming-soon/app-store.svg";
import googleButton from "assets/images/coming-soon/google-button.svg";
import huaweiButton from "assets/images/coming-soon/huawei-button.svg";

function GetMyalrajhi() {
  return (
    <div className="container get-my-alrajhi">
      <Container fluid className="inward-container">
        <Row>
          <div data-aos="fade-up" data-aos-delay="150">
            <h2 className="heading-36 mb-5">
              Get MY alrajhi.
              {/* <br /> */}
              {/* Your Trusted Shariah-Compliant Banking{" "} */}
            </h2>
            <div className="col" style={{ paddingBottom: "0px" }}>
              <div className="ccm-custom-style-container  ccm-custom-style-downloadsectionbuttons-353">
                <p className="d-flex flex-column flex-md-row justify-content-center align-items-center gap-4 gap-md-3 m-0">
                  <a
                    href="https://apps.apple.com/app/rize-my/id1587293861"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      maxWidth: "200px"
                    }}
                  >
                    <img
                      src={iosButton}
                      alt="Download on iOS"
                      width="100%"
                      height="auto"
                    />
                  </a>
                  <a
                    href="https://play.google.com/store/apps/details?id=my.com.alrajhibank.wick"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      maxWidth: "200px"
                    }}
                  >
                    <img
                      src={googleButton}
                      alt="Download on Google Play"
                      width="100%"
                      height="auto"
                    />
                  </a>
                  <a
                    href="https://appgallery.huawei.com/app/C104770227"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      maxWidth: "200px"
                    }}
                  >
                    <img
                      src={huaweiButton}
                      alt="Download on Huawei"
                      width="100%"
                      height="auto"
                    />
                  </a>
                </p>
              </div>
            </div>
          </div>
        </Row>
      </Container>
    </div>
  );
}

export default GetMyalrajhi;
